import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useWindowSize } from 'common/react/hooks/use-window-resize';
import { StatsSection } from 'widgets/statspro/js/components/common/stats-section';

import {
    Date,
    EventTypeFilter,
    TeamFilter,
    EventLocationFilter
} from './nav-items';
import { FilterButton } from 'common/react/components/FilterButton';

export const EventsListingNav = ({
    compseasonId,
    tags,
    locationTags,
    localTimezone,
    eventId
}) => {
    const [areFilterOptionsVisible, setAreFilterOptionsVisible] =
        useState(false);
    const [resetFilterBtnStyles, setResetFilterBtnStyles] = useState(false);

    const tagItems = useMemo(() => {
        return tags
            ? tags.split(',').map((tag) => ({
                  value: tag,
                  name: tag.replace('EventType:', '')
              }))
            : [];
    }, [tags]);

    const locationTagItems = useMemo(() => {
        return locationTags
            ? locationTags.split(',').map((tag) => ({
                  value: tag,
                  name: tag.replace('EventLocation:', '')
              }))
            : [];
    }, [locationTags]);

    const windowSize = useWindowSize();
    const isResponsive = windowSize.width < PULSE.app.measurements.desktop;

    const [resetFns, setResetFns] = useState([]);

    const resetHandler = (resetFunctions) => {
        resetFunctions.forEach((func) => func());
    };

    const addOnResetCallback = (resetFn) => {
        setResetFns((fns) => [...fns, resetFn]);
    };

    return (
        <div className="events-listing-nav">
            <StatsSection.Nav showFilterItems={isResponsive}>
                <StatsSection.NavItems>
                    {eventId && (
                        <Date
                            localTimezone={localTimezone}
                            eventId={eventId}
                            resetFilters={() => resetHandler(resetFns)}
                        />
                    )}
                </StatsSection.NavItems>
                <StatsSection.SettingsButton>
                    <FilterButton
                        classes="fixtures-nav__filter-button"
                        onChange={() =>
                            setAreFilterOptionsVisible((prev) => !prev)
                        }
                        areFilterOptionsVisible={areFilterOptionsVisible}
                        resetFilterBtnStyles={resetFilterBtnStyles}
                        setResetFilterBtnStyles={setResetFilterBtnStyles}
                        showActiveCircle
                    />
                </StatsSection.SettingsButton>
                {(areFilterOptionsVisible || isResponsive) && (
                    <StatsSection.ResponsiveRowItems>
                        <>
                            {tagItems.length && (
                                <EventTypeFilter
                                    tags={tagItems}
                                    addOnResetCallback={addOnResetCallback}
                                />
                            )}
                            {compseasonId && (
                                <TeamFilter
                                    compseasonId={compseasonId}
                                    addOnResetCallback={addOnResetCallback}
                                />
                            )}
                            {locationTagItems.length ? (
                                <EventLocationFilter
                                    tags={locationTagItems}
                                    addOnResetCallback={addOnResetCallback}
                                />
                            ) : null}
                        </>
                    </StatsSection.ResponsiveRowItems>
                )}
            </StatsSection.Nav>
        </div>
    );
};

EventsListingNav.propTypes = {
    compseasonId: PropTypes.string,
    tags: PropTypes.string,
    locationTags: PropTypes.string,
    localTimezone: PropTypes.string,
    eventId: PropTypes.string.isRequired
};
